import { Component, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../core/auth.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { DumbAdmin } from '../super-admin/DTOs/dumb-admin';
import { PortalLoginModalComponent } from './portal-login-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-portal-header',
  templateUrl: './public-portal-header.component.html',
  providers: [UIBlockingService],
  encapsulation: ViewEncapsulation.None
})
export class PublicPortalHeaderComponent {
  constructor(private blockUI: UIBlockingService
    , private router: Router
    , private authService: AuthService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {

  }
  myUser: DumbAdmin = new DumbAdmin();
  userIsLoggedIn: boolean = false;
  canAccessMemberContent: boolean = false;
    memberLevel: string = "";
  ngOnInit() {
    if (localStorage.getItem('contactId')) {
      this.userIsLoggedIn = true;
        this.memberLevel = localStorage.getItem('membershipLevel');
      this.myUser.firstName = localStorage.getItem('userFirstName');
      this.myUser.lastName = localStorage.getItem('userLastName');
      this.myUser.fullName = this.myUser.firstName + " " + this.myUser.lastName;
      this.myUser.contactId = localStorage.getItem('contactId');
      this.myUser.contactType = localStorage.getItem('contactType');
      this.myUser.emailAddress = localStorage.getItem('userEmailAddress');
    }
    this.canAccessMemberContent = this.authService.canAccessMemberOnlyContent();
  }
  logout() {
    this.authService.publicLogout();
    this.userIsLoggedIn = false;
    this.myUser = new DumbAdmin();
  }
  navToAdminPortal() {
    if (this.memberLevel == 'SuperAdmin') {
      return this.router.navigate(['/admin-portal/chamber/super-admin-management']);
    }
    else if (this.memberLevel == 'HealthAlliance') {
        return this.router.navigate(['/admin-portal/member/user-management']);
    }
    else if (this.canAccessMemberContent) {
      return this.router.navigate(['/admin-portal/member/dashboard']);
    }
    else return null;
  }
  openLoginModal() {
    const modalRef = this.modalService.open(PortalLoginModalComponent, { size: 'md' });
    modalRef.result.then(response => {
      this.userIsLoggedIn = true;
      this.myUser.firstName = localStorage.getItem('userFirstName');
      this.myUser.lastName = localStorage.getItem('userLastName');
      this.myUser.fullName = this.myUser.firstName + " " + this.myUser.lastName;
      this.myUser.contactId = localStorage.getItem('contactId');
      this.myUser.contactType = localStorage.getItem('contactType');
      this.myUser.emailAddress = localStorage.getItem('userEmailAddress');
    })
      .catch(err => {

      }).finally();
  }
}
